import { emit } from ".";
import * as Types from "../types";

const navigationMobileState = (
  menu: Types.SubItem,
  hasAppError: boolean,
  history: any,
  isSmall: boolean,
  setIsMenuExpandOnMobile: (a: boolean) => void,
) => {
  if (menu.href) {
    if (hasAppError) {
      window.location.href = menu.href;
    } else {
      history.push(menu.href);
      emit(menu.href);
    }
    if (!isSmall) {
      setIsMenuExpandOnMobile(false);
    }
  } else if (!isSmall) {
    setIsMenuExpandOnMobile(true);
  }
};

export default navigationMobileState;
